// extracted by mini-css-extract-plugin
export var actionButton = "_r9-0";
export var actionMenuContainer = "_r9-i";
export var bubble = "_r9-2";
export var bubbleActionMenu = "_r9-j";
export var bubbleContext = "_r9-6";
export var bubbleItems = "_r9-7";
export var customer = "_r9-3";
export var divider = "_r9-8";
export var fileList = "_r9-9";
export var hiddenComment = "_r9-o";
export var infoAbove = "_r9-a";
export var internal = "_r9-4";
export var lightActionButton = "_r9-1";
export var link = "_r9-b";
export var merchant = "_r9-5";
export var message = "_r9-c";
export var profilePicture = "_r9-e";
export var quillToolbarContainer = "_r9-f";
export var senderDate = "_r9-g";
export var senderDateCustomer = "_r9-h";
export var senderName = "_r9-d";
export var time = "_r9-k";
export var uploadedImage = "_r9-l";
export var username = "_r9-m";
export var xsmall = "_r9-n";